import { ArrowUpRight, Clock, InstagramLogo, MapPin, PhoneCall } from "@phosphor-icons/react";
import { contactInfo, media } from "@/data/siteContent";

const toTestSlug = (value) => value
  .toLocaleLowerCase("tr-TR")
  .replaceAll("ı", "i")
  .replaceAll("ğ", "g")
  .replaceAll("ü", "u")
  .replaceAll("ş", "s")
  .replaceAll("ö", "o")
  .replaceAll("ç", "c")
  .normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "")
  .replace(/[^a-z0-9]+/g, "-")
  .replace(/(^-|-$)/g, "");

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#050505] px-6 py-16 lg:px-8 lg:py-24">
      <div className="mx-auto grid max-w-7xl gap-10 lg:grid-cols-[1.2fr_0.8fr_0.8fr]">
        <div data-testid="footer-brand-block">
          <img
            data-testid="footer-logo-image"
            src={media.logo}
            alt="Has Kırıkhan logosu"
            className="h-auto w-full max-w-xs object-contain"
          />
          <p data-testid="footer-brand-name" className="sr-only">Has Kırıkhan Nakliyat</p>
          <p data-testid="footer-description" className="mt-5 max-w-xl text-base leading-relaxed text-slate-400">Kırıkhan’dan Hatay’ın tüm ilçelerine ve şehirler arası rotalara; planlı, güvenilir ve güçlü nakliyat hizmeti.</p>
          <a data-testid="footer-call-button" href={contactInfo.phoneHref} className="mt-8 inline-flex items-center gap-3 rounded-xl bg-[#25D366] px-6 py-4 font-black text-white transition-[transform,box-shadow,background-color] duration-300 hover:-translate-y-1 hover:bg-[#1DA851] hover:shadow-[0_8px_30px_rgba(37,211,102,0.25)]">
            <PhoneCall size={20} weight="bold" /> {contactInfo.phoneDisplay}
          </a>
        </div>

        <div data-testid="footer-quick-links">
          <h3 data-testid="footer-links-title" className="font-heading text-xl font-black text-white">Hızlı Bağlantılar</h3>
          <div className="mt-5 space-y-3">
            {["Hizmetler", "Hakkımızda", "Galeri", "Konum", "Güvence", "İletişim"].map((item) => (
              <a key={item} data-testid={`footer-link-${toTestSlug(item)}`} href={item === "İletişim" ? "#iletisim" : item === "Güvence" ? "#guvence" : item === "Galeri" ? "#galeri" : item === "Konum" ? "#konum" : item === "Hakkımızda" ? "#hakkimizda" : "#hizmetler"} className="flex items-center gap-2 text-slate-400 transition-colors duration-300 hover:text-orange-400">
                {item} <ArrowUpRight size={16} weight="bold" />
              </a>
            ))}
          </div>
        </div>

        <div data-testid="footer-contact-block">
          <h3 data-testid="footer-contact-title" className="font-heading text-xl font-black text-white">Çalışma Bilgileri</h3>
          <div className="mt-5 space-y-4 text-slate-400">
            <p data-testid="footer-hours" className="flex items-center gap-3"><Clock size={21} weight="duotone" className="text-orange-500" /> {contactInfo.hours}</p>
            <a data-testid="footer-map-link" href={contactInfo.googleMapsUrl} target="_blank" rel="noreferrer" className="flex items-center gap-3 transition-colors duration-300 hover:text-orange-400"><MapPin size={21} weight="duotone" className="text-orange-500" /> Google Haritalar’dan konuma git</a>
            <a data-testid="footer-instagram-link" href="#anasayfa" className="flex items-center gap-3 transition-colors duration-300 hover:text-orange-400"><InstagramLogo size={21} weight="duotone" className="text-orange-500" /> Instagram</a>
          </div>
        </div>
      </div>
      <div data-testid="footer-bottom" className="mx-auto mt-14 flex max-w-7xl flex-col justify-between gap-4 border-t border-white/10 pt-6 text-sm text-slate-500 sm:flex-row">
        <span data-testid="footer-copyright">© 2026 Has Kırıkhan Nakliyat. Tüm hakları saklıdır.</span>
        <span data-testid="footer-service-area">Kırıkhan • Hatay • Türkiye geneli</span>
      </div>
    </footer>
  );
}